// Утилиты для безопасного форматирования дат без ошибок гидратации

/**
 * Безопасное форматирование даты для SSR/CSR
 * Использует стандартные методы JavaScript для предотвращения различий между сервером и клиентом
 */
export function formatDateSafe(dateString, language = 'ru') {
    if (!dateString) return ''

    try {
        const date = new Date(dateString)

        // Проверяем, что дата валидна
        if (isNaN(date.getTime())) {
            return ''
        }

        // Используем стандартные методы JavaScript для одинакового результата на сервере и клиенте
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC' // Фиксированная временная зона для одинакового результата
        }

        const locale = language === 'ru' ? 'ru-RU' : 'en-US'

        return date.toLocaleDateString(locale, options)
    } catch (error) {
        console.warn('Error formatting date:', error)
        return ''
    }
}

/**
 * Короткий формат даты для карточек
 */
export function formatDateShort(dateString, language = 'ru') {
    if (!dateString) return ''

    try {
        const date = new Date(dateString)

        if (isNaN(date.getTime())) {
            return ''
        }

        const options = {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            timeZone: 'UTC'
        }

        const locale = language === 'ru' ? 'ru-RU' : 'en-US'

        return date.toLocaleDateString(locale, options)
    } catch (error) {
        console.warn('Error formatting date:', error)
        return ''
    }
}

/**
 * Получение ISO строки даты для атрибута datetime
 */
export function getDateTimeAttribute(dateString) {
    if (!dateString) return ''

    try {
        const date = new Date(dateString)

        if (isNaN(date.getTime())) {
            return ''
        }

        return date.toISOString().split('T')[0] // Только дата без времени
    } catch (error) {
        console.warn('Error getting datetime attribute:', error)
        return ''
    }
} 